import React, { useEffect, useState } from 'react'
import dark_version from "../../assets/img/dark-version.svg"
import dark_theme from "../../assets/img/dark-theme.svg"
import high_version from "../../assets/img/high-version.svg"
import rtl_version from "../../assets/img/rtl-version.svg"
import font_opensans from "../../assets/img/font-opensans.svg"
import font_quicksand from "../../assets/img/font-quicksand.svg"
import font_nunito from "../../assets/img/font-nunito.svg"
import font_raleway from "../../assets/img/font-raleway.svg"
import { Link, useLocation } from 'react-router-dom'


const ThemeSetting = () => {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    const [primaryColor, setPrimaryColor] = useState('');
    const [secondaryColor, setSecondaryColor] = useState('');
    const [bodyColor, setBodyColor] = useState('');
    const [borderColor, setBorderColor] = useState('');
    const [cardColorPicker, setCardColorPicker] = useState('');
    const [chartColor1, setChartColor1] = useState('');
    const [chartColor2, setChartColor2] = useState('');
    const [chartColor3, setChartColor3] = useState('');
    const [chartColor4, setChartColor4] = useState('');
    const [chartColor5, setChartColor5] = useState('');
    const [lunoColor, setLunoColor] = useState('theme-blue');
    const [isRtl, setIsRtl] = useState(false);
    const [isHorizontal, setIsHorizontal] = useState(false);
    const [headerDarkMode, setheaderDarkMode] = useState(false);
    const [borderRadius, setBorderRadius] = useState(false);
    const [sidebarVersion, setSidebarVersion] = useState(false);
    const [sidebarDarkMode, setSidebarDarkMode] = useState(false);
    const [sidebarBgImg, setSidebarBgImg] = useState(false);
    const [containerFuild, setContainerFuild] = useState(true);
    const [cardBox, setCardBox] = useState(false);
    const [headerFix, setHeaderFix] = useState(false);
    const [showDynamicSettings, setShowDynamicSettings] = useState(false);
    const [selectedFont, setSelectedFont] = useState('font-nunito');
    const location = useLocation();
    const path = location.pathname
    // Default font
    const [fontURL, setFontURL] = useState("");
    const [fontFamily, setFontFamily] = useState("");

    const handleFontChange = (event) => setSelectedFont(event.target.value);
    
    const applyFont = () => {
        if (fontURL && fontFamily) {
            // Inject font URL dynamically
            const existingLink = document.getElementById("dynamic-font");
            if (existingLink) {
                existingLink.href = fontURL;
            } else {
                const link = document.createElement("link");
                link.id = "dynamic-font";
                link.rel = "stylesheet";
                link.href = fontURL;
                document.head.appendChild(link);
            }

            // Apply font family
            document.body.style.fontFamily = `${fontFamily}, sans-serif`;
        }
    };

    const clearChanges = () => {
        document.body.style.fontFamily = "";
        setFontURL("");
        setFontFamily("");
        const existingLink = document.getElementById("dynamic-font");
        if (existingLink) {
            existingLink.remove();
        }
    };

    useEffect(() => {
        document.body.style.fontFamily =
            selectedFont === "font-opensans"
                ? "Open Sans, sans-serif"
                : selectedFont === "font-quicksand"
                    ? "Quicksand, sans-serif"
                    : selectedFont === "font-nunito"
                        ? "Nunito, sans-serif"
                        : "Raleway, sans-serif"; // Default to Raleway
    }, [selectedFont]);

    const handleThemeChange = (newTheme) => {
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    };
    const handleColorChange = (color, type) => {
        if (type === 'primary') setPrimaryColor(color);
        else if (type === 'secondary') setSecondaryColor(color);
        else if (type === 'body') setBodyColor(color);
        else if (type === 'card') setCardColorPicker(color);
        else if (type === 'border') setBorderColor(color);
        else if (type === 'chart1') setChartColor1(color);
        else if (type === 'chart2') setChartColor2(color);
        else if (type === 'chart3') setChartColor3(color);
        else if (type === 'chart4') setChartColor4(color);
        else if (type === 'chart5') setChartColor5(color);
        else if (type === 'luno') {
            setLunoColor(color);
            document.body.setAttribute('data-luno', color);
        }
    };
    const handleRtlToggle = () => setIsRtl(!isRtl);
    const handleHorizontal = (value) =>  setIsHorizontal(value); // Update the state with the checkbox value
    const handleHeaderFix = (value) => setHeaderFix(value); // Update the state with the checkbox value
    const handleDarkHeader = (value) =>  setheaderDarkMode(value); // Update the state with the checkbox value
    const handleBoderRedius = (value) =>  setBorderRadius(value); // Update the state with the checkbox value
    const handleSidebar2 = (value) =>  setSidebarVersion(value); // Update the state with the checkbox value
    const handleSidebarDarkMode = (value) => setSidebarDarkMode(value); // Update the state with the checkbox value
    const handleSidebarBgImg = (value) => setSidebarBgImg(value); // Update the state with the checkbox value
    const handleCardBox = (value) => setCardBox(value); // Update the state with the checkbox value
    const handleConatinerFuild = (value) =>  setContainerFuild(value); // Update the state with the checkbox value
    const toggleDynamicSettings = (value) => setShowDynamicSettings(value); // Update the state with the checkbox value
    
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        document.documentElement.style.setProperty('--primary-color', primaryColor);
        document.documentElement.style.setProperty('--secondary-color', secondaryColor);
        document.documentElement.style.setProperty('--body-color', bodyColor);
        document.documentElement.style.setProperty('--card-color', cardColorPicker);
        document.documentElement.style.setProperty('--border-color', borderColor);
        document.documentElement.style.setProperty('--chart-color1', chartColor1);
        document.documentElement.style.setProperty('--chart-color2', chartColor2);
        document.documentElement.style.setProperty('--chart-color3', chartColor3);
        document.documentElement.style.setProperty('--chart-color4', chartColor4);
        document.documentElement.style.setProperty('--chart-color5', chartColor5);
        document.body.classList.toggle('rtl_mode', isRtl);
        document.body.classList.toggle('h-menu', isHorizontal);
    }, [theme, primaryColor, secondaryColor, lunoColor, isRtl, bodyColor, cardColorPicker, borderColor, chartColor1, chartColor2, chartColor3, chartColor4, chartColor5]);

    useEffect(() => {
        if (isRtl) {
            document.body.classList.add('layout-1', 'rtl_mode');
        }
        if (isHorizontal) {
            document.body.classList.add('layout-1', 'h-menu');

        }
        if (borderRadius) {
            document.body.classList.add('layout-1', 'radius-0');

        }
        // Clean up by removing the classes when the component unmounts
        return () => {
            if (isRtl) {
                document.body.classList.remove('layout-1', 'rtl_mode');
            }
            if (isHorizontal) {
                document.body.classList.remove('layout-1', 'h-menu');
            }
            if (borderRadius) {
                document.body.classList.remove('layout-1', 'radius-0');

            }

        };
    }, [isRtl, isHorizontal, borderRadius]);
    useEffect(() => {
        if (path === "/landing/blog" || path === "/landing" || path === "/landing/app-blog-detail" || path === "/fitness/landing"
            || path === "/hospital/landing" || path === "/hrms/landing" || path === "/job-portal/landing" || path === "/crm/landing" || path ==="/crypto/landing"
            || path === "/ecommerce/landing"
        ) {
        } else {
            const header = document.querySelector('header');
            if (header) {
                if (headerDarkMode) {
                    header.classList.add('dark');
                } else {
                    header.classList.remove('dark');
                }
                if (headerFix) {
                    header.classList.add('sticky-top');
                } else {
                    header.classList.remove('sticky-top');
                }
            }
        }
    }, [headerDarkMode, headerFix]);

    useEffect(() => {
        const cardElements = document.querySelectorAll('.card.overflow-hidden') || document.querySelectorAll('.card'); // Select the card elements
        if (cardElements.length > 0) {
            cardElements.forEach((cardElement) => {
                if (cardBox) {
                    cardElement.classList.add('shadow-active'); // Add the shadow class
                } else {
                    cardElement.classList.remove('shadow-active'); // Remove the shadow class
                }
            });
        }
        return () => {
            cardElements.forEach((cardElement) => {
                cardElement.classList.remove('shadow-active');
            });
        };
    }, [cardBox]);

    useEffect(() => {
        const sidebar = document.querySelector('.sidebar');
        if (sidebar) {
            if (sidebarVersion) {
                sidebar.classList.add('version-2');
            } else {
                sidebar.classList.remove('version-2');
            }
            if (sidebarDarkMode) {
                sidebar.classList.add('dark');
            } else {
                sidebar.classList.remove('dark');
            }
            if (sidebarBgImg) {
                sidebar.classList.add('sidebar-img-bg');
            } else {
                sidebar.classList.remove('sidebar-img-bg');
            }
        }
    }, [sidebarVersion, sidebarDarkMode, sidebarBgImg]);

    useEffect(() => {
        if (path.startsWith('/docs')) {
            // Set pageHeaderFix and sidebarDarkMode to true when path matches /docs
            setHeaderFix(true);
            setSidebarDarkMode(true);
        } else {
            const header = document.querySelector('header');
            if (header) {
                if (headerDarkMode) {
                    header.classList.add('dark');
                } else {
                    header.classList.remove('dark');
                }
                if (headerFix) {
                    header.classList.add('sticky-top');
                } else {
                    header.classList.remove('sticky-top');
                }
            }
        }
    }, [path, headerDarkMode, headerFix]);

    useEffect(() => {

        if (path === "/landing/blog" || path === "/landing" || path === "/landing/app-blog-detail" || path ==="/fitness/landing"
            || path === "/hospital/landing" || path === "/hrms/landing" || path === "/job-portal/landing" || path === "/crm/landing" || path === "/crypto/landing"
            || path === "/ecommerce/landing" || path === "/event/landing" || path === "/inventory/landing" || path === "/real-estate/landing" ||
            path === "/real-estate/landing" || path === "/university/landing" || path === "/crm/app-blog" || path === "/app-blog-detail" || path==="/ecommerce/app-blog"
            || path === "/crypto/app-blog"
        ) {
        } else {
            if (path.startsWith('/docs')) {
                setContainerFuild(false)
            } else {
                const mainContainers = document.querySelectorAll('.container, .container-fluid'); // Select both classes
                mainContainers.forEach((mainContainer) => {
                    if (containerFuild) {
                        mainContainer.classList.add('container-fluid');
                        mainContainer.classList.remove('container');
                    } else {
                        mainContainer.classList.add('container');
                        mainContainer.classList.remove('container-fluid');
                    }
                });
            }

        }

    }, [containerFuild]);
    const handleRemove = () => {
        const modals = document.querySelectorAll('.modal-backdrop.fade.show'); // Select elements with these classes
        modals.forEach((modal) => {
            // Ensure proper class removal
            modal.classList.remove('modal-backdrop', 'fade', 'show');

            // Add new classes if needed
            modal.classList.add('modal', 'fade');
        });
        document.body.style.overflow = '';
        document.body.style.paddingRight = ''; 
        document.body.style.fontFamily = '';
    };

    return (
        <div className="modal-content">
            <div className="px-xl-4 modal-header">
                <h5 className="modal-title">Theme Setting</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body custom_scroll">
                <div className="card fieldset border border-primary p-3 setting-theme mb-4">
                    <span className="fieldset-tile text-primary bg-card">Color Settings</span>
                    <ul className="list-unstyled d-flex choose-skin mb-0">
                        {['black', 'indigo', 'blue', 'cyan', 'green', 'orange', 'blush', 'red'].map(color => (
                            <li key={color} onClick={() => { handleColorChange(`theme-${color}`, 'luno'); setShowDynamicSettings(false) }}>
                                <div className={color}></div>
                            </li>

                        ))}
                        <li data-theme="dynamic" onClick={() => { toggleDynamicSettings(); handleColorChange(`theme-dynamic`, 'luno') }}>
                            <div className="dynamic"><i className="fa fa-paint-brush"></i></div>
                        </li>
                    </ul>
                    <div className={!showDynamicSettings ? "card fieldset border border-primary p-3 dt-setting mt-4" : "card fieldset border border-primary p-3 mt-4"}>
                        <span className="fieldset-tile text-primary bg-card">Dynamic Color Settings</span>
                        <div className="row g-3">
                            <div className="col-7">
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <input type="color" id="primaryColorPicker" className="btn bg-primary avatar xs me-2" value={primaryColor} onChange={(e) => { handleColorChange(e.target.value, "primary") }} title="Choose your color" />
                                        <label>Primary Color</label>
                                    </li>
                                    <li>
                                        <input type="color" id="secondaryColorPicker" className="btn bg-secondary avatar xs me-2" value={secondaryColor} onChange={(e) => { handleColorChange(e.target.value, "secondary") }} title="Choose your color" />
                                        <label>Secondary Color</label>
                                    </li>
                                    <li>
                                        <input type="color" id="BodyColorPicker" className="btn btn-outline-secondary bg-body avatar xs me-2" value={bodyColor} onChange={(e) => { handleColorChange(e.target.value, "body") }} title="Choose your color" />
                                        <label>Site Background</label>
                                    </li>
                                    <li>
                                        <input type="color" id="CardColorPicker" className="btn btn-outline-secondary bg-card avatar xs me-2" value={cardColorPicker} onChange={(e) => { handleColorChange(e.target.value, "card") }} title="Choose your color" />
                                        <label>Widget Background</label>
                                    </li>
                                    <li>
                                        <input type="color" id="BorderColorPicker" className="btn btn-outline-secondary  bg-card avatar xs me-2" value={borderColor} onChange={(e) => { handleColorChange(e.target.value, "border") }} title="Choose your color" />
                                        <label>Border Color</label>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-5">
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <input type="color" id="chartColorPicker1" className="btn chart-color1 avatar xs me-2" value={chartColor1} onChange={(e) => { handleColorChange(e.target.value, "chart1") }} title="Choose your color" />
                                        <label>Chart Color 1</label>
                                    </li>
                                    <li>

                                        <input type="color" id="chartColorPicker2" className="btn chart-color2 avatar xs me-2" value={chartColor2} onChange={(e) => { handleColorChange(e.target.value, "chart2") }} title="Choose your color" />
                                        <label>Chart Color 2</label>
                                    </li>
                                    <li>
                                        <input type="color" id="chartColorPicker3" className="btn chart-color3 avatar xs me-2" value={chartColor3} onChange={(e) => { handleColorChange(e.target.value, "chart3") }} title="Choose your color" />
                                        <label>Chart Color 3</label>
                                    </li>
                                    <li>
                                        <input type="color" id="chartColorPicker4" className="btn chart-color4 avatar xs me-2" value={chartColor4} onChange={(e) => { handleColorChange(e.target.value, "chart4") }} title="Choose your color" />
                                        <label>Chart Color 4</label>
                                    </li>
                                    <li>
                                        <input type="color" id="chartColorPicker5" className="btn chart-color5 avatar xs me-2" value={chartColor5} onChange={(e) => { handleColorChange(e.target.value, "chart5") }} title="Choose your color" />
                                        <label>Chart Color 5</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="setting-mode mb-4">
                    <h6 className="card-title">Light/Dark & Contrast Layout</h6>
                    <div className="c_radio d-flex text-center">
                        <label className="m-1 theme-switch" htmlFor="theme-switch">
                            <input
                                type="checkbox"
                                id="theme-switch"
                                checked={theme === 'dark'}
                                onChange={() => handleThemeChange(theme === 'dark' ? 'light' : 'dark')}
                            />
                            <span className="card p-2">
                                <img className="img-fluid" src={dark_version} alt="Dark Mode" />
                            </span>
                        </label>
                        <label className="m-1 theme-dark" htmlFor="theme-switch-dark">
                            <input
                                type="checkbox"
                                id="theme-switch-dark"
                                checked={theme === 'theme-dark'}
                                onChange={() => handleThemeChange(theme === 'theme-dark' ? 'light' : 'theme-dark')}
                            />
                            <span className="card p-2">
                                <img className="img-fluid" src={dark_theme} alt="Theme Dark Mode" />
                            </span>
                        </label>
                        <label className="m-1 theme-high-contrast" htmlFor="theme-high-contrast">
                            <input
                                type="checkbox"
                                id="theme-high-contrast"
                                checked={theme === 'high-contrast'}
                                onChange={() => handleThemeChange(theme === 'high-contrast' ? 'light' : 'high-contrast')}
                            />
                            <span className="card p-2">
                                <img className="img-fluid" src={high_version} alt="High Contrast" />
                            </span>
                        </label>
                        <label className="m-1 theme-rtl" htmlFor="theme-rtl">
                            <input
                                type="checkbox"
                                id="theme-rtl"
                                onChange={handleRtlToggle}
                            // Add functionality for RTL if needed
                            />
                            <span className="card p-2">
                                <img className="img-fluid" src={rtl_version} alt="RTL Mode!" />
                            </span>
                        </label>
                    </div>
                </div>
                <div className="setting-font">
                    <h6 className="card-title">Google Font Settings</h6>
                    <div className="c_radio d-flex text-center font_setting">
                        <label className="m-1" htmlFor="font-opensans">
                            <input type="radio" name="font" id="font-opensans" value="font-opensans"
                                checked={selectedFont === 'font-opensans'} onChange={handleFontChange} />
                            <span className="card p-2">
                                <img className="img-fluid" src={font_opensans} alt="Open Sans" />
                            </span>
                        </label>
                        <label className="m-1" htmlFor="font-quicksand">
                            <input type="radio" name="font" id="font-quicksand" value="font-quicksand" checked={selectedFont === 'font-quicksand'} onChange={handleFontChange} />
                            <span className="card p-2">
                                <img className="img-fluid" src={font_quicksand} alt="Quicksand" />
                            </span>
                        </label>
                        <label className="m-1" htmlFor="font-nunito">
                            <input type="radio" name="font" id="font-nunito" value="font-nunito" checked={selectedFont === 'font-nunito'} onChange={handleFontChange} />
                            <span className="card p-2">
                                <img className="img-fluid" src={font_nunito} alt="Nunito" />
                            </span>
                        </label>
                        <label className="m-1" htmlFor="font-raleway">
                            <input type="radio" name="font" id="font-raleway" value="font-raleway" checked={selectedFont === 'font-raleway'} onChange={handleFontChange} />
                            <span className="card p-2">
                                <img className="img-fluid" src={font_raleway} alt="Raleway" />
                            </span>
                        </label>
                    </div>
                </div>
                <div className="m-1 p-3 bg-body rounded-4 mb-4">
                    <p>Dynamic Font Settings</p>
                    <div className="mb-2">
                        <label className="form-label small text-muted mb-0">Enter font URL</label>
                        <input
                            id="font_url"
                            type="text"
                            className="form-control"
                            placeholder="http://fonts.cdnfonts.com/css/vonfont"
                            value={fontURL}
                            onChange={(e) => setFontURL(e.target.value)}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label small text-muted mb-0">Enter font family name</label>
                        <input
                            id="font_family"
                            type="text"
                            className="form-control"
                            placeholder="vonfont"
                            value={fontFamily}
                            onChange={(e) => setFontFamily(e.target.value)}
                        />
                    </div>
                    <button
                        id="font_apply"
                        type="button"
                        className="btn btn-primary"
                        onClick={applyFont}
                    >
                        Save Changes
                    </button>
                    <button
                        id="font_cancel"
                        type="button"
                        className="btn btn-secondary"
                        style={{ marginLeft: "5px" }}
                        onClick={clearChanges}
                    >
                        Clear Changes
                    </button>
                </div>
                <div className="setting-more mb-4">
                    <h6 className="card-title">More Setting</h6>
                    <ul className="list-group list-group-flush list-group-custom fs-6">
                        {!path.startsWith('/docs') && <li className="list-group-item">
                            <div className="form-check form-switch pageheader-switch mb-1">
                                <input type="checkbox" id="horizontal_menu_version" name="horizontal" value={isHorizontal} className="form-check-input"

                                    onChange={(e) => handleHorizontal(e.target.checked)}
                                    checked={isHorizontal} />
                                <label className="form-check-label" htmlFor="horizontal_menu_version">Horizontal Menu Version</label>
                            </div>

                        </li>}
                        <li className="list-group-item">
                            <div className="form-check form-switch pageheader-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="PageHeader"
                                    onChange={(e) => handleHeaderFix(e.target.checked)}
                                    checked={headerFix} />
                                <label className="form-check-label" htmlFor="PageHeader">Page Header Fix</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="form-check form-switch pageheader-dark-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="PageHeader_dark"
                                    onChange={(e) => handleDarkHeader(e.target.checked)}
                                    checked={headerDarkMode} />
                                <label className="form-check-label" htmlFor="PageHeader_dark">Page Header Dark Mode</label>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="form-check form-switch radius-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="BorderRadius"

                                    onChange={(e) => handleBoderRedius(e.target.checked)}

                                    checked={borderRadius} />
                                <label className="form-check-label" htmlFor="BorderRadius">Border Radius none</label>
                            </div>
                        </li>
                        {!path.startsWith('/docs') && <li className="list-group-item">
                            <div className="form-check form-switch radius-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="sidebar_version_2"
                                    onChange={(e) => handleSidebar2(e.target.checked)}
                                    checked={sidebarVersion} />
                                <label className="form-check-label" htmlFor="sidebar_version_2">Sidebar Version 2</label>
                            </div>
                        </li>}

                        <li className="list-group-item">
                            <div className="form-check form-switch sidebardark-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="SidebarDark"
                                    onChange={(e) => handleSidebarDarkMode(e.target.checked)}
                                    checked={sidebarDarkMode} />
                                <label className="form-check-label" htmlFor="SidebarDark">Enable Dark! ( Sidebar )</label>
                            </div>
                        </li>
                        {!path.startsWith('/docs') && <li className="list-group-item">
                            <div className="form-check form-switch sidebardark-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="background_image"
                                    onChange={(e) => handleSidebarBgImg(e.target.checked)}
                                    checked={sidebarBgImg} />
                                <label className="form-check-label" htmlFor="background_image">Background Image (Sidebar)</label>
                            </div>
                        </li>}

                        <li className="list-group-item">
                            <div className="form-check form-switch fluid-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="fluidLayout"
                                    onChange={(e) => handleConatinerFuild(e.target.checked)}
                                    checked={containerFuild} />
                                <label className="form-check-label" htmlFor="fluidLayout">Container Fluid</label>
                            </div>
                        </li>

                        {!path.startsWith('/docs') && <li className="list-group-item">
                            <div className="form-check form-switch sidebardark-switch mb-1">
                                <input className="form-check-input" type="checkbox" id="card_box_shadow"
                                    onChange={(e) => handleCardBox(e.target.checked)}
                                    checked={cardBox} />
                                <label className="form-check-label" htmlFor="card_box_shadow">Card Box-Shadow</label>
                            </div>
                        </li>}

                    </ul>
                </div>
                <div className="mb-4">
                    <Link className="btn lift btn-outline-secondary" to="/marketing" onClick={handleRemove}>Marketing page</Link>
                    <Link className="btn lift btn-outline-secondary ml-5" to="/onepgae-uikit/onepage" onClick={handleRemove} >Landing page</Link>
                    <Link className="btn lift btn-outline-secondary ml-5" to="/onepgae-uikit" onClick={handleRemove}>One page Ui Kit Elements</Link>
                </div>
            </div>
            <div className="modal-footer d-flex justify-content-start text-center">
                <button type="button" className="btn flex-fill btn-primary lift">Save Changes</button>
                <button type="button" className="btn flex-fill btn-white border lift" data-bs-dismiss="modal">Close</button>
            </div>

        </div>

    )
}

export default ThemeSetting